<div class="flex justify-between items-center px-4 py-2">
  <h1 class="text-2xl font-bold text-zinc-800 ">{{ 'myAddresses' | translate }}</h1>

  <button
    type="button"
    (click)="add.emit()"
    class="px-4 py-2 bg-[#FBEAEA] rounded-full text-[var(--navbar-light-coler)] text-lg flex items-center justify-center gap-2 transition">
   {{ 'addNewAddress' | translate }}
  
  </button>
</div>

@for (address of addresses; track $index) {
  <div class="card relative w-full rounded-3xl dark:bg-white/10 mb-4"
   (click)="onSelect(address)">

    <div class="absolute top-1/2 -translate-y-1/2 flex flex-col z-10 gap-2 -right-4">
      <i class="pi pi-pencil px-2 bg-[#FAFAFA] border border-gray-400 rounded-full py-2 cursor-pointer"
         (click)="edit.emit(address); $event.stopPropagation()"></i>

      <i class="pi pi-trash px-2 bg-[#DC2626] text-white rounded-full py-2 cursor-pointer"
         (click)="delete.emit(address); $event.stopPropagation()"></i>
    </div>

    <p-fieldset [legend]="'home'|translate" >
      <div class="flex pe-4 items-center dark:bg-white/10 justify-between">
        <p class="text-2xl font-bold text-zinc-800">
          <span class="size-[33px] px-1 py-0.5 text-[20px] rounded-full bg-[#00BC7D] text-white">
            <i class="fa-solid fa-location-dot"></i>
          </span>
          {{address.city}}
        </p>

        <p class="text-zinc-600">{{address.phone}}</p>
      </div>

      <div class="mt-4">
        <p class="text-zinc-600">{{address.street}}</p>
      </div>
    </p-fieldset>

  </div>
}
